import { render, staticRenderFns } from "./BlockChain.vue?vue&type=template&id=14e5edca"
import script from "./BlockChain.vue?vue&type=script&lang=js"
export * from "./BlockChain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports